import range from 'lodash-es/range';

import { Input, Output, Directive, OnChanges, ChangeDetectorRef, EventEmitter } from '@angular/core';

@Directive()
export class PagerComponentDef implements OnChanges {
    /**
     * Total number of items
     * @type {number}
     */
    @Input({
        required: true
    })
    total!: number;

    @Output()
    pagerChange = new EventEmitter<PagerComponentDef>();

    /**
     * Max qty of pages on pme page
     * @type {number}
     */
    @Input({
        required: true
    })
    pageSize!: number;

    /**
     * Max page links to show
     * @type {number}
     */
    @Input({
        required: true
    })
    pagerSize!: number;

    /**
     * Total number of pages
     * @type {number}
     */
    pagesCount!: number;

    /**
     * Current offset
     * @type {number}
     */
    offset!: number;

    /**
     * Current page
     * @type {number}
     */
    @Input()
    page: number = 0;

    /**
     * List of pages to display
     * @type {number[]}
     */
    pages!: number[];

    constructor(protected changeDetectorRef: ChangeDetectorRef) {}

    /**
     * Makes sure that data is assigned properly
     * and udpate pagesCount
     */
    ngOnChanges() {
        this.total = this.total || 0;
        this.pageSize = this.pageSize || 16;
        this.pagerSize = this.pagerSize || 5;

        this.pagesCount = Math.ceil(this.total / this.pageSize);
        this.pick();
    }

    /**
     * Selects page to show
     * @param {number} page
     */
    pick(page: number | undefined = this.page): void {
        this.page = Math.max(1, Math.min(page || 0, this.pagesCount));
        this.offset = (this.page - 1) * this.pageSize;

        // update pages display
        this.pages = range(
            Math.max(1, Math.min(this.page - Math.floor(this.pagerSize / 2), this.pagesCount - this.pagerSize + 1)),
            1 + Math.min(this.pagesCount, Math.max(this.page + Math.floor(this.pagerSize / 2), this.pagerSize))
        );
        this.changeDetectorRef.detectChanges();
        this.pagerChange.emit(this);
    }

    /**
     * Goes to previous page
     */
    prev(): void {
        this.pick(this.page ? this.page - 1 : 0);
    }

    /**
     * Goes to next page
     */
    next(): void {
        this.pick(this.page ? this.page + 1 : 1);
    }

    /**
     * Goes to fist page
     */
    first(): void {
        this.pick(0);
    }

    /**
     * Goes to last page
     */
    last(): void {
        this.pick(this.pagesCount + 1);
    }
}
